<template>
    <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

        <!-- Sidebar - Brand -->
        <router-link to="/" class="sidebar-brand d-flex align-items-center justify-content-center mb-3">
            <div class="sidebar-brand-icon">
                <img src="../../assets/img/logo-lateral.png"  height="60" width="150" class="rounded mt-3">
            </div>
            
            <!-- <div class="sidebar-brand-text mx-3">
                <sup>{{ sys_verssion }}</sup>
            </div> -->
        </router-link>

        <!-- Divider -->
        <hr class="sidebar-divider">

        <li class="nav-item">
            <router-link to="/" class="nav-link">
                <font-awesome-icon icon="tachometer-alt" />
                <span class="menubar-link"><b>Dashboard</b></span>
            </router-link>
        </li>


        <li class="nav-item">
            <router-link :to="{name: 'Denuncias', params: {get: 'Denuncias'} }" class="nav-link">
                <font-awesome-icon icon="user-secret" size="xs" />
                <span class="menubar-link">{{menu_nome}}</span>
            </router-link>
        </li>

        <div v-if="type > 1">
            <li class="nav-item">
                    <router-link :to="{name: 'Recados' }" class="nav-link">
                        <font-awesome-icon icon="voicemail" size="xs" />
                        <span class="menubar-link">Recados</span>
                    </router-link>
            </li>

            <li class="nav-item">
                    <router-link :to="{name: 'Elogios', params: {get: 'Elogios'} }" class="nav-link">
                        <font-awesome-icon icon="headset" size="xs" />
                        <span class="menubar-link">SAC</span>
                    </router-link>
            </li>
        </div>


        <div v-if="type > 1">
            <!-- Divider -->
            <hr class="sidebar-divider">

            <!-- Heading -->
            <div class="sidebar-heading">
                Relatórios
            </div>

            <li class="nav-item">
                <router-link :to="{name: 'rel_ISD', params: {get: 'ISD'} }" class="nav-link">
                    <font-awesome-icon icon="assistive-listening-systems" size="xs" />
                    <span class="menubar-link">ISD</span>
                </router-link>
            </li>

            <li class="nav-item hidden">
                <router-link :to="{name: 'rel_select' }" class="nav-link">
                    <font-awesome-icon icon="paste" size="xs" />
                    <span class="menubar-link">Ligações</span>
                </router-link>
            </li>

            <li class="nav-item">
                <router-link :to="{name: 'Bilhetagem' }" class="nav-link">
                    <font-awesome-icon icon="phone" size="xs" />
                    <span class="menubar-link">Bilhetagem</span>
                </router-link>
            </li>

            <!-- Divider -->
            <hr class="sidebar-divider">

            <!-- Heading -->
            <div class="sidebar-heading">
                Administração
            </div>

            <li class="nav-item">
                <router-link :to="{name: 'Usuarios', params: {get: 'Usuarios'} }" class="nav-link">
                    <font-awesome-icon icon="file-invoice" size="xs" />
                    <span class="menubar-link">Cadastro</span>
                </router-link>
            </li>

            <li class="nav-item">
                <router-link :to="{name: 'Feriados' }" class="nav-link">
                    <font-awesome-icon icon="file-invoice" size="xs" />
                    <span class="menubar-link">Feriados</span>
                </router-link>
            </li>

            <li class="nav-item">
                <router-link :to="{name: 'Blacklist' }" class="nav-link">
                    <font-awesome-icon icon="list-alt" size="xs" />
                    <span class="menubar-link">Números bloqueados</span>
                </router-link>
            </li>

            <li class="nav-item" v-if="type == 3 && monitor_lig == 1">
                <router-link :to="{name: 'Monitor' }" class="nav-link">
                    <font-awesome-icon icon="eye" size="xs" />
                    <span class="menubar-link">Monitor Ramais</span>
                </router-link>
            </li>

            <li class="nav-item">
                <router-link :to="{name: 'Emails' }" class="nav-link">
                    <font-awesome-icon icon="mail-bulk" size="xs" />
                    <span class="menubar-link">Emails</span>
                </router-link>
            </li>

            <li class="nav-item" v-if="type == 3">
                <router-link :to="{name: 'Auditoria' }" class="nav-link">
                    <font-awesome-icon icon="chart-area" size="xs" />
                    <span class="menubar-link">Auditoria</span>
                </router-link>
            </li>

            <li class="nav-item">
                <router-link :to="{name: 'confSystem', params: {get: 'Sistema'} }" class="nav-link">
                    <font-awesome-icon icon="cog" size="xs" />
                    <span class="menubar-link">Configurações</span>
                </router-link>
            </li>
        </div>

        <!-- Divider -->
        <hr class="sidebar-divider">

        <li class="nav-item">
            <a class="nav-link" data-toggle="modal" data-target="#modal-logof">
                <font-awesome-icon icon="sign-out-alt" size="xs" />
                <span class="menubar-link">Sair</span>
            </a>
        </li>

        <!-- Divider -->
        <hr class="sidebar-divider d-none d-md-block">

        <!-- Sidebar - Brand -->
        <a class="sidebar-brand d-flex align-items-center justify-content-center" href="http://www.dad.eng.br" target="_blank">
            <div class="sidebar-brand-text mx-3">
                <img src="../../assets/img/dad-logo.png" alt="" height="70">
            </div>
        </a>
    </ul>
</template>

<script>
    export default {
        name: "template-menubar",

        computed: {
            type() { 
                return this.$store.state.user.type;
            },

			menu_nome(){
				return ( this.$store.state.config_view_menu.denuncia_nome );
            },
            
            monitor_lig(){
                return ( this.$store.state.config_view_menu.monitor_ramais_lig );
            },
        },   
    };
</script>

<style>
  .nav-item span {
      margin-left: 4px;
  }

  .menubar-link {
      color: white;
      transition: all 0.5s;
  }

  .menubar-link:hover {
      color: rgb(224, 185, 133);
  }
</style>
